import {
  CheckAvailabilityRequest,
  CheckAvailabilityResponse11,
  CheckAvailabilityResponse12,
  CheckAvailabilityResponseProduct,
} from './CheckAvailability'
import { LineGroup } from './LineGroup'
import { PartsBasketCreds } from '../security/interfaces'
import { ProductLocationModel } from 'interfaces'
import { makeNewCartVehicle, SellerCartData } from 'cart'
import EmbeddedServiceProvider from '../../services/EmbeddedServiceProvider'
import miscellaneousVehicle from '../../features/search/Results/utils/miscellaneousVehicle'
import { CART_VERSION_STRING, MY_PLACE_SELLER } from 'common'
import { ShoppingCartProduct } from 'src/store/models/ShoppingCartModels'

export class CartOnlyCommunications {
  /**
   * converts an incoming "checkAvailabilityResponse" into a standard shopping cart
   */

  public static availabilityResponseToCart(
    resp: CheckAvailabilityResponse12
  ): SellerCartData {
    const data: SellerCartData = {
      vehicles: [],
      version: CART_VERSION_STRING,
    }
    const groupedLines = new Map<number, LineGroup>()
    for (const line of resp?.lineInfo?.line || []) {
      const lineGroup = groupedLines.get(line.lineNo) ?? new LineGroup()
      lineGroup.addProduct(line)
      groupedLines.set(line.lineNo, lineGroup)
    }
    const newCartVehicle = makeNewCartVehicle({ ...miscellaneousVehicle })
    data.vehicles.push({
      ...newCartVehicle,
      sellers: [
        {
          ...MY_PLACE_SELLER,
          locations: [],
          noteToStore: '',
          poNumber: '',
        },
      ],
      specifications: [],
      laborResults: [],
      quoteSourceId: undefined,
      orderFormData: {
        poNumber: '',
        noteToStore: '',
        customerName: '',
        personalNote: '',
      },
    })
    const seller = data.vehicles[0].sellers[0]

    groupedLines.forEach((lineGroup) => {
      const product = lineGroup.reduce()
      let location = seller.locations.find(
        (location) =>
          location.locationId === product.orderSelections[0].locationId
      )
      if (!location) {
        location = {
          ...product.location.find(
            (location) =>
              location.locationId === product.orderSelections[0].locationId
          ),
          parts: [],
          deliveryDetail: {},
        }

        seller.locations.push(location)
      }
      if (product && location) {
        location.parts.push({
          ...product,
          quantityRequested: product.orderSelections[0].quantityRequested,
          bundleInfo: [],
          errors: product.errors ?? [],
        })
      }
    })

    return data
  }

  public static convertProduct(
    line: CheckAvailabilityResponseProduct,
    alternateLocations: Array<ProductLocationModel>
  ): ShoppingCartProduct {
    const product: ShoppingCartProduct = {
      activeLocationId: line.locationId,
      allianceProductId: undefined,
      alternateParts: undefined,
      errors: [],
      brand: line.brand,
      brandName: line.brand,
      brandUrl: undefined,
      c2cURL: undefined,
      caProp65: undefined,
      catLineCode: undefined,
      description: line.description,
      extendedDescription: undefined,
      fromYear: undefined,
      header: undefined,
      images: undefined,
      info: undefined,
      isGfx: false,
      group: undefined,
      lineCode: line.manufacturerCode,
      lineNo: line.lineNo,
      location: alternateLocations,
      manufacturerName: undefined,
      orderNumber: undefined,
      orderSelections: [
        {
          locationId: line.locationId,
          quantityRequested: Number(line.quantityRequested),
        },
      ],
      partDescriptionId: 0,
      partNumber: line.partNumber,
      perCarQty: 0,
      replacementParts: undefined,
      status: line.status,
      subBrand: '',
      subBrandName: '',
      type: line.type,
    }
    return product
  }

  public static convertLocations = (
    lines: Array<CheckAvailabilityResponseProduct>
  ): Array<ProductLocationModel> => {
    const convertedLocations: Array<ProductLocationModel> = []
    for (const line of lines) {
      const location: ProductLocationModel = {
        locationId: line.locationId,
        seqNo: line.seqNo,
        locType: line.locationStatus,
        called: line.locationDescription,
        unitOfMeasure: line.unitOfMeasure,
        minQty: Number(line.minOrderQty),
        displayMinQty: Number(line.minOrderQty),
        qtyAvailable: Number(line.quantityAvailable),
        list: Number(line.unitListPrice),
        cost: Number(line.unitCostPrice),
        coreList: Number(line.unitListCore),
        coreCost: Number(line.unitCorePrice),
        isSelected: false,
        packNumUnits: 1,
      }
      convertedLocations.push(location)
    }
    return convertedLocations
  }

  public static checkAvailability = async (
    creds: PartsBasketCreds,
    req: CheckAvailabilityRequest
  ): Promise<CheckAvailabilityResponse11 | CheckAvailabilityResponse12> => {
    const partsBasket = JSON.stringify(req)
    const resp = await EmbeddedServiceProvider.checkAvailability(
      creds,
      partsBasket
    )

    return resp.data
  }
}
